"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelbankUSDManager = void 0;
const abstractManager_1 = require("./abstractManager");
class ModelbankUSDManager extends abstractManager_1.USDManager {
    constructor() {
        super(...arguments);
        this.parseInformation = (data) => {
            const { agentToken, documentType, interactionId, platform, securitySSR_AccessToken, securitySSR_RefreshToken, sessionId, userName } = data;
            this.information = {
                agentTokenRequestPromise: null,
                accessToken: securitySSR_AccessToken,
                agentToken,
                documentType,
                interactionId,
                platform,
                refreshToken: securitySSR_RefreshToken,
                sessionId,
                userName,
            };
        };
        this.parseMethods = (data) => {
            const raiseN2InIvr = (signatureKeyPositions, progressId) => new Promise((resolve, reject) => {
                const windowsCall = {
                    succeded: this.windowFunctions.RaiseN2InIvrSuccess,
                    failed: this.windowFunctions.RaiseN2InIvrFailure,
                };
                data.RaiseN2InIvr(signatureKeyPositions, progressId);
                this.windowFunctions.RaiseN2InIvrSuccess = () => {
                    windowsCall.succeded();
                    resolve(progressId);
                };
                this.windowFunctions.RaiseN2InIvrFailure = (error) => {
                    windowsCall.failed(error);
                    reject(error);
                };
            });
            const raiseN2OTPInIvr = (otpId, progressId) => new Promise((resolve, reject) => {
                const windowsCall = {
                    succeded: this.windowFunctions.RaiseN2OTPInIvrSuccess,
                    failed: this.windowFunctions.RaiseN2OTPInIvrFailure,
                };
                data.RaiseN2OTPInIvr(otpId, progressId);
                this.windowFunctions.RaiseN2OTPInIvrSuccess = () => {
                    windowsCall.succeded(progressId);
                    resolve(progressId);
                };
                this.windowFunctions.RaiseN2OTPInIvrFailure = (error) => {
                    windowsCall.failed(error);
                    reject(error);
                };
            });
            const createPasswordOnboarding = (sessionId, onbData) => new Promise((resolve, reject) => {
                data.OB_SetKeysInIvr(sessionId, onbData);
                window.createPasswordOnboardingFinished = (ivrCode, reolveData) => {
                    resolve(ivrCode);
                };
            });
            const verifyDataInIvr = ivrData => new Promise((resolve, reject) => {
                const windowsCall = {
                    succeded: this.windowFunctions.verifyDataInIvrSuccess,
                    failed: this.windowFunctions.verifyDataInIvrFailure,
                };
                data.VerifyDataInIvr(ivrData);
                this.windowFunctions.verifyDataInIvrSuccess = () => {
                    windowsCall.succeded();
                    resolve(ivrData.otpId);
                };
                this.windowFunctions.verifyDataInIvrFailure = (error) => {
                    windowsCall.failed(error);
                    reject(error);
                };
            });
            const registerTrace = (sessionId, actionCode, operationError, errorMessage, obj) => data.RegisterTrace(sessionId, actionCode, operationError, errorMessage, obj);
            const getAgentAccessToken = () => __awaiter(this, void 0, void 0, function* () {
                return new Promise((resolve, reject) => {
                    this.getInformation().agentTokenRequestPromise = { resolve, reject };
                    data.GetAgentAccessToken(this.getInformation().sessionId);
                });
            });
            const refreshAgentToken = (agentAccessToken) => {
                var _a, _b;
                if (!agentAccessToken) {
                    (_a = this.getInformation().agentTokenRequestPromise) === null || _a === void 0 ? void 0 : _a.reject('missing agentToken');
                }
                this.getInformation().agentToken = agentAccessToken;
                (_b = this.getInformation().agentTokenRequestPromise) === null || _b === void 0 ? void 0 : _b.resolve(agentAccessToken);
            };
            const assistedAuthenticateSuccess = (accessToken, refreshToken, role) => { var _a; return data.AssistedAuthenticateSuccess((_a = this.information) === null || _a === void 0 ? void 0 : _a.sessionId, accessToken, refreshToken, role); };
            const onLogoutSuccess = () => data.OnLogoutSuccess(this.getInformation().sessionId);
            const onInvalidSession = () => data.OnInvalidSession(this.getInformation().sessionId);
            const onExpiredSignatureKey = () => data.SignatureKeyExpired(this.getInformation().sessionId);
            this.methods = {
                raiseN2InIvr,
                raiseN2OTPInIvr,
                createPasswordOnboarding,
                registerTrace,
                // logAgentAccess = createAgentAccessLogFunction(registerTrace, sessionId);
                // logSuccessfulAgentOperation = createSuccessfulAgentOperationLogFunction(registerTrace, sessionId);
                // logFailedAgentOperation = createFailedAgentOperationLogFunction(registerTrace, sessionId);
                assistedAuthenticateSuccess,
                getAgentAccessToken,
                onLogoutSuccess,
                onInvalidSession,
                onExpiredSignatureKey,
                refreshAgentToken,
                verifyDataInIvr,
            };
        };
    }
}
exports.ModelbankUSDManager = ModelbankUSDManager;
//# sourceMappingURL=modelbankManager.js.map